'use strict';

require('../modules/forms/forms');

angular.module('far.forms.inviteUserForm', ['dekky.forms'])
.service('inviteUserForm', function(form) {
	var userInvite = form('userInvite');

	userInvite
		.addField('members_invite_email', 'text', {
			validators: {
				required: true
			},
			options: {
				placeholder: 'E-mail',
				uniqueUser: '',
				class: 'form__item width-184 margin_r_20'
			}
		})
		.addField('members_invite_last_name', 'text', {
			validators: {
				required: true
			},
			options: {
				placeholder: 'Фамилия',
				class: 'form__item width-184 margin_r_20'
			}
		})
		.addField('members_invite_first_name', 'text', {
			validators: {
				required: true
			},
			options: {
				placeholder: 'Имя',
				class: 'form__item width-184'
			}
		});

	return userInvite;
});